import React, { useEffect } from "react";
import { API_C2S, auth } from "shared/services";
import { useMain, useMainState } from "modules/app/contexts";
import * as _ from "lodash";
import * as http from "modules/app/utils/http";
import {
  recoveryCustomers,
  recoveryTotalTabs,
  registerCustomers,
  registerTotalTabs,
} from "modules/app/utils/storage/customers";

function LoadContacts({ children }) {
  const {
    contacts,
    totalActivities,
    totalAll,
    totalFavorites,
    totalTodo,
    totalVisits,
  } = useMainState();
  const {
    updateContacts,
    overwriteTotals,
    updateMain,
    contactsLoading,
  } = useMain();
  const mainState = useMainState();
  const currentUser = auth.currentUser;

  useEffect(() => {
    async function initialLoadContacts() {
      contactsLoading(true);
      const [data, initialTotals] = await http.getAllTabsCustomers();

      updateContacts([...data]);
      overwriteTotals(initialTotals);
      contactsLoading(false);
    }

    async function initialLoadFromCache() {
      const totals = await recoveryTotalTabs(currentUser?.uid);
      const list = await recoveryCustomers(currentUser?.uid);

      if (list && totals) {
        updateContacts([...list]);
        overwriteTotals(totals);
      }

      initialLoadContacts();
    }

    async function loadExternalUsers() {
      try {
        const resultExternalUsers = await API_C2S.get(
          "/real_estate_manager/users"
        );
        const externalUsers = resultExternalUsers?.data?.data || [];

        if (externalUsers) {
          updateMain({
            ...mainState,
            externalUsers: externalUsers,
          });
        }
      } catch (error) {
        console.log("sem acesso a API do c2s");
      }
    }

    initialLoadFromCache();
    loadExternalUsers();
  }, []);

  useEffect(() => {
    const newTotalsToCache = {
      totalActivities,
      totalAll,
      totalFavorites,
      totalTodo,
      totalVisits,
    };

    // without this condition the cache gonna be rewrite with zero
    if (totalAll > 0) {
      registerTotalTabs(currentUser.uid, newTotalsToCache);
    }
  }, [totalActivities, totalAll, totalFavorites, totalTodo, totalVisits]);

  useEffect(() => {
    function updateCacheContacts() {
      if (contacts?.length > 0) {
        const list = _.uniqBy(contacts, "id");
        registerCustomers(currentUser.uid, list);
      }
    }

    updateCacheContacts();
  }, [contacts]);

  return <>{children}</>;
}

export default LoadContacts;
